// The restaurateur's share kit (FacilityCommunity.jsx), drawn on a canvas and
// downloaded as PNG: a portrait card for Instagram (« Dans 4 listes
// YummiTracker ») and a square window sticker with the QR of their most
// followed list. Colours of the YummiTracker lists (PARIS theme of the app).
const NAVY = '#1C2B4A';
const CREAM = '#F4EEE3';
const GOLD = '#C9A227';
const BURGUNDY = '#9E3B33';
const SLATE = '#5B6B82';
const GREEN = '#2F7D4F';
const FONT = 'Inter, "Helvetica Neue", Arial, sans-serif';

/** Writes text over at most maxLines lines of maxWidth; returns the y under it. */
function wrap(ctx, text, x, y, maxWidth, lineHeight, maxLines = 3) {
  const words = String(text).split(/\s+/);
  let line = '';
  let lines = 0;
  for (let i = 0; i < words.length; i += 1) {
    const test = line ? `${line} ${words[i]}` : words[i];
    if (ctx.measureText(test).width > maxWidth && line) {
      lines += 1;
      if (lines === maxLines) { ctx.fillText(`${line}…`, x, y); return y + lineHeight; }
      ctx.fillText(line, x, y);
      y += lineHeight;
      line = words[i];
    } else {
      line = test;
    }
  }
  if (line) { ctx.fillText(line, x, y); y += lineHeight; }
  return y;
}

/** The photo, cropped to fill w × h. */
function cover(ctx, img, x, y, w, h) {
  const r = Math.max(w / img.width, h / img.height);
  const sw = w / r, sh = h / r;
  ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h);
}

/** Portrait card 1080 × 1350. t: { headline, sub, verified, footer } already translated. */
export function drawCard(canvas, { facilityName, photo, t }) {
  canvas.width = 1080;
  canvas.height = 1350;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = NAVY;
  ctx.fillRect(0, 0, 1080, 1350);
  ctx.fillStyle = CREAM;
  ctx.fillRect(60, 60, 960, 1230);
  if (photo) {
    cover(ctx, photo, 60, 60, 960, 640);
  } else {
    ctx.fillStyle = BURGUNDY;
    ctx.fillRect(60, 60, 960, 640);
  }
  ctx.textBaseline = 'top';
  ctx.fillStyle = BURGUNDY;
  ctx.font = `700 34px ${FONT}`;
  ctx.fillText(String(facilityName).toUpperCase().slice(0, 40), 110, 750);
  ctx.fillStyle = NAVY;
  ctx.font = `800 76px ${FONT}`;
  let y = wrap(ctx, t.headline, 110, 806, 860, 88, 2);
  ctx.fillStyle = SLATE;
  ctx.font = `500 38px ${FONT}`;
  y = wrap(ctx, t.sub, 110, y + 16, 860, 50, 2);
  if (t.verified) {
    ctx.fillStyle = GREEN;
    ctx.font = `700 38px ${FONT}`;
    ctx.fillText(t.verified, 110, y + 16);
  }
  ctx.fillStyle = GOLD;
  ctx.fillRect(110, 1180, 120, 8);
  ctx.fillStyle = NAVY;
  ctx.font = `700 34px ${FONT}`;
  ctx.fillText(t.footer, 110, 1206);
}

/** Square sticker 1200 × 1200 with the QR (a canvas). t: { title, sub, scan } already translated. */
export function drawSticker(canvas, { facilityName, qr, t }) {
  canvas.width = 1200;
  canvas.height = 1200;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = NAVY;
  ctx.fillRect(0, 0, 1200, 1200);
  ctx.textAlign = 'center';
  ctx.textBaseline = 'top';
  ctx.fillStyle = GOLD;
  ctx.font = `700 40px ${FONT}`;
  ctx.fillText(String(facilityName).toUpperCase().slice(0, 40), 600, 80);
  ctx.fillStyle = CREAM;
  ctx.font = `800 72px ${FONT}`;
  const y = wrap(ctx, t.title, 600, 150, 1040, 84, 2);
  ctx.font = `500 36px ${FONT}`;
  ctx.fillStyle = '#D9C3A0';
  wrap(ctx, t.sub, 600, y + 10, 1040, 46, 2);
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(370, 470, 460, 460);
  if (qr) ctx.drawImage(qr, 400, 500, 400, 400);
  ctx.fillStyle = CREAM;
  ctx.font = `700 40px ${FONT}`;
  ctx.fillText(t.scan, 600, 980);
  ctx.fillStyle = GOLD;
  ctx.font = `700 34px ${FONT}`;
  ctx.fillText('YummiTracker', 600, 1060);
}

/** Saves a canvas as a PNG file. */
export function downloadCanvas(canvas, filename) {
  canvas.toBlob((blob) => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL?.(url), 1000);
  }, 'image/png');
}

/** An image loaded for drawing (same origin as the API in production), or null. */
export const loadImage = (src) => new Promise((resolve) => {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});
